import React from 'react';
// this function component is used to load the footer in the page
function Footer() {
    return (
        <footer className="wrapper">
            <p>Copyright <span aria-hidden="true">©</span> 2020 scanit.com </p>
        </footer>
    );
}
export default Footer;